<script module lang="ts">
  export interface Topic {
    topic: string;
    count: number;
  }
</script>

<script lang="ts">
  import { fade } from "svelte/transition";
  import Button from "$lib/ui/button/button.svelte";
  import Badge from "$lib/ui/badge/badge.svelte";
  import { Colors } from "$lib/ui/badge";
  import { toTitleCase } from "$lib/utils/text";
  import { ChevronDown, ChevronUp } from "lucide-svelte";
  import { filter, sortBy } from "lodash";

  export const {
    topics,
    onChange,
    disabled = false,
  }: {
    topics: Topic[];
    onChange?: (selectedTopics?: string[]) => void;
    disabled?: boolean;
  } = $props();

  let showAllTopics = $state(false);
  let selectedTopics = $state<string[]>([]);
  let displayedTopics = $derived.by(() => {
    let tempTopics = showAllTopics
      ? topics
      : filter(topics, (topic) => selectedTopics.includes(topic.topic.toLowerCase()));
    return sortBy(tempTopics, "topic");
  });
</script>

<div class="flex flex-col gap-4 py-4" transition:fade>
  <div class="w-full">
    <div class="flex justify-between items-center mb-2">
      <span>
        {#if topics.length == 0}
          <span>No Topics Available</span>
        {/if}
        {#if selectedTopics.length == 0 && topics.length > 0}
          <span>All Topics Selected</span>
        {/if}
        {#if selectedTopics.length > 0 && topics.length > 0}
          <span>{selectedTopics.length}/{topics.length} Topics Selected</span>
        {/if}
      </span>
      {#if topics.length > 0}
        <Button variant="ghost" onclick={() => (showAllTopics = !showAllTopics)} {disabled}>
          Select Topics
          <span class="pl-2 pr-4 w-5 h-5">
            {#if showAllTopics}
              <ChevronUp />
            {:else}
              <ChevronDown />
            {/if}
          </span>
        </Button>
      {/if}
    </div>
    <div class="flex flex-wrap gap-2">
      {#each displayedTopics as topic}
        <button
          onclick={() => {
            selectedTopics = selectedTopics.includes(topic.topic.toLowerCase())
              ? selectedTopics.filter((t) => t !== topic.topic.toLowerCase())
              : [...selectedTopics, topic.topic.toLowerCase()];
            if (onChange) {
              onChange(selectedTopics);
            }
          }}
        >
          <Badge
            color={selectedTopics.length > 0 && selectedTopics.includes(topic.topic.toLowerCase())
              ? Colors.GREEN
              : Colors.GRAY}
          >
            <span class="px-1">{toTitleCase(topic.topic)} [{topic.count}]</span>
          </Badge>
        </button>
      {/each}
    </div>
  </div>
</div>
